import React, { useEffect, useState } from 'react';
import { BiGroup, BiBook, BiBuilding, BiTime } from 'react-icons/bi';
import StatCard from '../common/StatCard';
import { settingsAPI } from '../../services/api';
import { DEFAULT_SCHOOL_STATS, withStatDefaults } from '../../utils/schoolStats';

const StatsSection = () => {
  const [schoolStats, setSchoolStats] = useState(DEFAULT_SCHOOL_STATS);

  useEffect(() => {
    settingsAPI.get().then((res) => {
      setSchoolStats(withStatDefaults(res.data?.data?.settings?.schoolStats));
    }).catch(() => {});
  }, []);

  const statsData = [
    { icon: BiGroup,    number: schoolStats.students,   suffix: '',  label: 'Students Enrolled',   color: 'primary'   },
    { icon: BiBook,     number: schoolStats.teachers,   suffix: '+', label: 'Qualified Teachers',  color: 'secondary' },
    { icon: BiBuilding, number: schoolStats.classrooms, suffix: '+', label: 'Smart Classrooms',    color: 'primary'   },
    { icon: BiTime,     number: schoolStats.years,      suffix: '+', label: 'Years of Excellence', color: 'secondary' },
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gray-50 relative overflow-hidden">
      <div className="absolute inset-0 opacity-40"
        style={{
          backgroundImage: 'radial-gradient(circle, #c7d2fe 1px, transparent 1px)',
          backgroundSize: '40px 40px',
        }}
      />
      {/* accent strip at top */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-accent-400" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-secondary-600 font-bold text-xs uppercase tracking-widest mb-2">Our Achievements</p>
          <h2 className="text-4xl font-serif font-bold text-primary-700">School in Numbers</h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {statsData.map((stat, idx) => (
            <StatCard
              key={idx}
              icon={stat.icon}
              number={stat.number}
              suffix={stat.suffix}
              label={stat.label}
              color={stat.color}
              delay={idx * 0.15}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
